import React from 'react';

const LogoCloud = ({ 
  title = 'Designed for leading organizations',
  logos = [
    { name: 'Company 1', url: 'https://via.placeholder.com/150x50?text=Logo+1' },
    { name: 'Company 2', url: 'https://via.placeholder.com/150x50?text=Logo+2' },
    { name: 'Company 3', url: 'https://via.placeholder.com/150x50?text=Logo+3' },
    { name: 'Company 4', url: 'https://via.placeholder.com/150x50?text=Logo+4' },
    { name: 'Company 5', url: 'https://via.placeholder.com/150x50?text=Logo+5' },
  ],
  grayscale = true,
  className = '' 
}) => {
  return (
    <div className={`text-center ${className}`}>
      {title && (
        <p className="text-sm text-muted-foreground mb-8">{title}</p>
      )}
      <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
        {logos.map((logo, index) => (
          <img
            key={index}
            src={logo.url}
            alt={logo.name}
            className={`h-8 md:h-10 object-contain ${grayscale ? 'grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

LogoCloud.builderConfig = {
  props: {
    title: {
      type: 'text',
      label: 'Title',
      default: 'Designed for leading organizations',
    },
    grayscale: {
      type: 'boolean',
      label: 'Grayscale Logos',
      default: true,
    },
  },
};

export default LogoCloud;
